export default {
  isSound: true,
  isMusic: true,
  isAnimations: true,
}